import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

import { ISystemParamCategoryChipColors } from "./system-params.category.models";

interface ISystemParamsCategoryChipStyledProps extends IStyledAttributes {
  $colors: ISystemParamCategoryChipColors;
  $isSelected: boolean;
}

export const SystemParamsCategorySwitchStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "system-params-category-switch",
  },
)`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 8px;
  margin-bottom: 14px;
  border: 1px solid ${greyMui._200};
  border-radius: 12px;
  background-color: ${greyMui._50};
  transition:
    filter 0.55s ease-out,
    backdrop-filter 0.55s ease-out;

  &.inner-item-editing {
    filter: blur(2px) grayscale(100%);
    backdrop-filter: blur(3px);
    pointer-events: none;
  }
`;

export const SystemParamsCategoryChipStyled = styled.button.attrs<ISystemParamsCategoryChipStyledProps>(
  {
    type: "button",
  },
)<ISystemParamsCategoryChipStyledProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 22px;
  padding: 2px 12px;
  border: none;
  border-radius: 999px;
  background-color: ${({ $colors }) => $colors.backgroundColor};
  color: ${({ $colors }) => $colors.color};
  box-shadow: ${({ $colors }) => $colors.boxShadow};
  font: inherit;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  appearance: none;
  transition:
    background-color 0.35s cubic-bezier(0.22, 1, 0.36, 1),
    color 0.35s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.35s cubic-bezier(0.22, 1, 0.36, 1);

  &:hover {
    background-color: ${({ $isSelected, $colors }) =>
      $isSelected ? $colors.backgroundColor : greyMui._200};
    color: ${({ $isSelected, $colors }) =>
      $isSelected ? $colors.color : greyMui._900};
  }

  &:active {
    background-color: ${({ $isSelected, $colors }) =>
      $isSelected ? $colors.backgroundColor : greyMui._300};
  }

  &:focus-visible {
    outline: 2px solid ${({ $colors }) => $colors.color};
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition:
      background-color 0.15s ease,
      color 0.15s ease,
      box-shadow 0.15s ease;
  }
`;
